import React, {useEffect, useState} from "react";
import Modal from "react-bootstrap/Modal";
import I18n from "i18n-js";
import {
  isDefined,
  parseAmount,
  parseShipmentAddress,
  stringifyHomePickUpFavoriteHour,
  SUBMISSION_LISTS_HOME_PICK_UP_AFTERNOON_HOURS,
  SUBMISSION_LISTS_HOME_PICK_UP_MORNING_HOURS
} from "../../utils/utils";


const SubmissionListHomePickUpPopup = ({
  showPickUpRequestPopup,
  onShipmentManagementHandler,
  onCancel,
  setShowPickUpRequestPopup,
  productsCountToRequestPickUp,
  companyToRequestPickUp,
  submissionListsNumbers,
  homePickUpPrice,
  homePickUpFavoriteDay,
  setHomePickUpFavoriteDay,
  homePickUpFavoriteHour,
  setHomePickUpFavoriteHour,
  homePickUpCourierId,
  setHomePickUpCourierId,
  couriers,
  homePickUpDates,
  countries,
  setShowErrorModal,
  environment
}) => {

  const [ invalidDay, setInvalidDay ] = useState(false);
  const [ homePickUpAddressId, setHomePickUpAddressId ] = useState(null);
  const [ homePickUpAvailableAddresses, setHomePickUpAvailableAddresses ] = useState(null);

  useEffect(() => {
    if (showPickUpRequestPopup)
      getAvailableAddressesForHomePickUp();
    else {
      setHomePickUpAddressId(null);
      setHomePickUpAvailableAddresses(null);
    }
  }, [showPickUpRequestPopup])

  useEffect(() => {
    if (homePickUpFavoriteDay) {
      const fromDateIntVale = parseInt(homePickUpDates.range[0].replaceAll('-', ''));
      setInvalidDay(fromDateIntVale > parseInt(homePickUpFavoriteDay.replaceAll('-', '')));
    }
  }, [homePickUpFavoriteDay]);

  // console.log('homePickUpAddressId: ', homePickUpAddressId);
  // console.log('homePickUpAvailableAddresses: ', homePickUpAvailableAddresses);
  // console.log('countries: ', countries);


  // Funzione che gestisce la chiusura della modale
  const handleClose = () => {
    setShowPickUpRequestPopup(false);
  }


  // Funzione che chiede al server gli indirizzi che l'utente potrebbe usare per prenotare
  // il ritiro a domicilio di N submission lists diverse
  const getAvailableAddressesForHomePickUp = () => {
    const url = `/submission_lists/home_pick_up/user_addresses.json?submission_lists_numbers=${submissionListsNumbers.join(',')}`;
    fetch(url, {
      method: 'GET'
    })
      .then(response => response.json())
      .then((data) => {
        setHomePickUpAddressId(data?.default_address_id);
        setHomePickUpAvailableAddresses(data?.addresses);
      })
      .catch((error) => {
        console.error("ERROR:", error);
        setShowErrorModal(true);
      });
  }


  // Funzione che gestisce il click sul tasto Conferma del popup
  const handleConfirm = async () => {
    const responseCode = await onShipmentManagementHandler(homePickUpFavoriteDay, stringifyHomePickUpFavoriteHour(homePickUpFavoriteHour), homePickUpCourierId, homePickUpAddressId);
    if (responseCode.toString() === '400')
      setInvalidDay(true);
    else
      handleClose();
  }


  // Funzione che verifica se le fasce orarie scelte dall'utente siano valide oppure no
  const validHomePickUpHour = () => {
    let partialAvailability = 0;
    let globalAvailability = 0;

    for (const slot of ['morning', 'afternoon']) {
      if (homePickUpFavoriteHour[slot].from && !homePickUpFavoriteHour[slot].to)
        return false;
      if (!homePickUpFavoriteHour[slot].from && homePickUpFavoriteHour[slot].to)
        return false;
      if (homePickUpFavoriteHour[slot].from && homePickUpFavoriteHour[slot].to) {
        partialAvailability = parseInt(homePickUpFavoriteHour[slot].to) - parseInt(homePickUpFavoriteHour[slot].from)
        if (partialAvailability <= 0)
          return false;
        else if (environment === 'backoffice' && partialAvailability >= 4)
          return true;
        else
          globalAvailability += partialAvailability;
      }
    }

    if (environment === 'backoffice' &&
      homePickUpFavoriteHour['morning'].from && homePickUpFavoriteHour['morning'].to &&
      homePickUpFavoriteHour['afternoon'].from && homePickUpFavoriteHour['afternoon'].to &&
      parseInt(homePickUpFavoriteHour['morning'].to) === parseInt(homePickUpFavoriteHour['afternoon'].from) &&
      parseInt(homePickUpFavoriteHour['afternoon'].to) - parseInt(homePickUpFavoriteHour['morning'].from) >= 4)
      return true;

    return globalAvailability >= 5;
  }



  return (
    <Modal show={showPickUpRequestPopup} onHide={handleClose} animation={false} size="lg" centered>
      <Modal.Body>
        <div className="font-jost px-4 py-2">
          <div className="border-bottom-aiBlue-2px mb-4">
            <h4 className="mb-1">
              <b>
              { I18n.t('js.indexSubmissionListsPage.requestPickUpTitle').replaceAll(':submission_lists_count', submissionListsNumbers.length) }
              </b>
            </h4>
          </div>

          <div className="mb-2">
            {I18n.t('js.indexSubmissionListsPage.pickUpRequest.homePickUpBooking')}
            <ul className="pl-4 py-3">
              {submissionListsNumbers.map((submissionListNumber) => {
                return <li key={submissionListNumber}>
                  {submissionListNumber}
                </li>
              })}
            </ul>
          </div>

          {
            homePickUpAvailableAddresses?.length > 0 &&
              <div className="mt-2 mb-4">
                <p>{I18n.t('js.indexSubmissionListsPage.pickUpRequest.homePickUpAddressSelection')}</p>
                {
                  homePickUpAvailableAddresses.map(a => {
                    const shipmentAvailableByProvince = homePickUpAddressId == a.id || countries[a.country_id]['provinces'].includes(a.province);

                    return <div id={'address_' + a.id} key={'address_' + a.id}
                                className="row px-4 ml-1 pt-3 w-100 text-left custom-control">
                      <input
                        type="radio"
                        id={'home_pick_up_address_' + a.id}
                        name={'home_pick_up_address_' + a.id}
                        value={a.id}
                        className="aiG-radio custom-control-input"
                        disabled={!shipmentAvailableByProvince}
                        checked={homePickUpAddressId == a.id}
                        onChange={() => setHomePickUpAddressId(a.id)}
                      />
                      <label
                        className="aiG-label-radio custom-control-label font-weight-normal"
                        id={"label_address_" + a.id}
                        htmlFor={'home_pick_up_address_' + a.id}
                      >
                        {
                          a.residence &&
                          <p className="mb-0">
                            <b>{I18n.t('js.newUserAddressForm.residenceCompact')}</b>
                          </p>
                        }
                        {parseShipmentAddress(a)}
                        {
                          !shipmentAvailableByProvince &&
                          <p className="mb-0">
                            <b>{I18n.t(`js.editSubmissionListPage.webComponent.draft.home_pick_upNotAvailableOnThisProvince`)}</b>
                          </p>
                        }
                      </label>
                    </div>
                  })
                }
              </div>
          }

          <p>
            {I18n.t('js.indexSubmissionListsPage.pickUpRequest.homePickUpFavoriteDayMsg')}&nbsp;
            {homePickUpDates.range_italian_format[0]}&nbsp;
            {I18n.t('js.indexSubmissionListsPage.pickUpRequest.homePickUpFavoriteDayMsg2')}
          </p>

          <p className="my-4">
            {I18n.t('js.indexSubmissionListsPage.pickUpRequest.homePickUpFavoriteDayMsg3')}:
          </p>

          <div className="row">
            <div className="col-12 col-sm-4 d-block mt-1 pt-2 pb-1">
              <div className="d-flex justify-content-start">
                <small className="color-gray mr-2 mb-2">
                  {I18n.t('js.editSubmissionListPage.webComponent.draft.homePickUpFavoriteDayTitle').toUpperCase()}
                </small>
              </div>

              <input
                type="date"
                className="form-control supplementary-item-form-input border-left-radius-3px-imp w-100"
                name="favorite_day"
                id="favorite_day"
                min={homePickUpDates.range_iso_format[0]}
                defaultValue={homePickUpFavoriteDay}
                onInput={(e) => setHomePickUpFavoriteDay(e.target.value)}
              />
            </div>

            <div className="col-12 col-sm-4 d-block mt-1 pt-2 pb-1 pl-0">
              <div className="d-flex justify-content-start">
                <small className="color-gray mr-2 mb-2">
                  {I18n.t('js.editSubmissionListPage.webComponent.draft.homePickUpTimeRangeMorning').toUpperCase()}
                </small>
              </div>

              <div className="d-flex">
                <select
                  className="form-control supplementary-item-form-input supplementary-item-form-select w-100"
                  name="from_morning"
                  id="from_morning"
                  value={homePickUpFavoriteHour?.morning?.from ? homePickUpFavoriteHour.morning.from : ''}
                  onChange={(e) => setHomePickUpFavoriteHour({ ...homePickUpFavoriteHour, morning: { ...homePickUpFavoriteHour.morning, from: e.target.value } })}
                >
                  <option value="" id="from_morning">
                    {I18n.t('js.editSubmissionListPage.webComponent.draft.homePickUpTimeRangeFrom')}
                  </option>
                  {SUBMISSION_LISTS_HOME_PICK_UP_MORNING_HOURS.slice(0, -1).map((hour) =>(
                    <option value={hour} id={`morning_${hour}`} key={`morning_${hour}`}>
                      {hour}:00
                    </option>
                  ))}
                </select>

                <select
                  className="form-control supplementary-item-form-input supplementary-item-form-select w-100 ml-2"
                  name="to_morning"
                  id="to_morning"
                  value={homePickUpFavoriteHour?.morning?.to ? homePickUpFavoriteHour.morning.to : ''}
                  onChange={(e) => setHomePickUpFavoriteHour({ ...homePickUpFavoriteHour, morning: { ...homePickUpFavoriteHour.morning, to: e.target.value } })}
                >
                  <option value="" id="to_morning">
                    {I18n.t('js.editSubmissionListPage.webComponent.draft.homePickUpTimeRangeTo')}
                  </option>
                  {SUBMISSION_LISTS_HOME_PICK_UP_MORNING_HOURS.slice(1).map((hour) =>(
                    <option value={hour} id={`morning_${hour}`} key={`morning_${hour}`}>
                      {hour}:00
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-12 col-sm-4 d-block mt-1 pt-2 pb-1 pl-0">
              <div className="d-flex justify-content-start">
                <small className="color-gray mr-2 mb-2">
                  {I18n.t('js.editSubmissionListPage.webComponent.draft.homePickUpTimeRangeAfternoon').toUpperCase()}
                </small>
              </div>


              <div className="d-flex">
                <select
                  className="form-control supplementary-item-form-input supplementary-item-form-select w-100"
                  name="from_afternoon"
                  id="from_afternoon"
                  value={homePickUpFavoriteHour?.afternoon?.from ? homePickUpFavoriteHour.afternoon.from : ''}
                  onChange={(e) => setHomePickUpFavoriteHour({ ...homePickUpFavoriteHour, afternoon: { ...homePickUpFavoriteHour.afternoon, from: e.target.value } })}
                >
                  <option value="" id="from_afternoon">
                    {I18n.t('js.editSubmissionListPage.webComponent.draft.homePickUpTimeRangeFrom')}
                  </option>
                  {SUBMISSION_LISTS_HOME_PICK_UP_AFTERNOON_HOURS.slice(0, -1).map((hour) =>(
                    <option value={hour} id={`afternoon_${hour}`} key={`afternoon_${hour}`}>
                      {hour}:00
                    </option>
                  ))}
                </select>

                <select
                  className="form-control supplementary-item-form-input supplementary-item-form-select w-100 ml-2"
                  name="to_afternoon"
                  id="to_afternoon"
                  value={homePickUpFavoriteHour?.afternoon?.to ? homePickUpFavoriteHour.afternoon.to : ''}
                  onChange={(e) => setHomePickUpFavoriteHour({ ...homePickUpFavoriteHour, afternoon: { ...homePickUpFavoriteHour.afternoon, to: e.target.value } })}
                >
                  <option value="" id="to_afternoon">
                    {I18n.t('js.editSubmissionListPage.webComponent.draft.homePickUpTimeRangeTo')}
                  </option>
                  {[ ...(new Set(SUBMISSION_LISTS_HOME_PICK_UP_AFTERNOON_HOURS.slice(1).concat(environment === 'backoffice' ? [19]: [])))].map((hour) =>(
                    <option value={hour} id={`afternoon_${hour}`} key={`afternoon_${hour}`}>
                      {hour}:00
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {
              couriers?.length > 0 &&
              <div className="col-12 col-sm-4 d-block mt-1 pt-2 pb-1">
                <div className="d-flex justify-content-start">
                  <small className="color-gray mr-2 mb-2">
                    {I18n.t('js.outboundDashboard.shipmentData.courier').toUpperCase()}
                  </small>
                </div>

                <select
                  className="form-control supplementary-item-form-input supplementary-item-form-select w-100"
                  name="courier_id"
                  id="courier_id"
                  value={homePickUpCourierId ? homePickUpCourierId : ''}
                  onChange={(e) => setHomePickUpCourierId(e.target.value)}
                >
                  <option value="" id="courier_id">
                    Select courier
                  </option>
                  {couriers.map((courier) =>(
                    <option value={courier[0]} id={courier[0]} key={courier[0]}>
                      {courier[1]}
                    </option>
                  ))}
                </select>
              </div>
            }

            {
              invalidDay &&
                <div className="col-12 pt-3 text-aiBlue">
                  <i>{I18n.t('js.editSubmissionListPage.webComponent.draft.homePickUpFavoriteDateInvalidMessage')}</i>
                </div>
            }
          </div>

          {
            isDefined(productsCountToRequestPickUp) &&
            isDefined(companyToRequestPickUp) &&
            productsCountToRequestPickUp < companyToRequestPickUp.shipping_discount_products_threshold &&
            <div className="my-4 pt-3">
              <p>
                {I18n.t('js.indexSubmissionListsPage.pickUpRequest.denyService1').replaceAll(':items_count', companyToRequestPickUp.shipping_discount_products_threshold)}&nbsp;
                {
                  isDefined(homePickUpPrice) && homePickUpPrice > 0 &&
                    <span>{I18n.t('js.indexSubmissionListsPage.pickUpRequest.denyService2').replaceAll(':home_pick_up_price', parseAmount(homePickUpPrice, 2, true))}&nbsp;</span>
                }
                {I18n.t('js.indexSubmissionListsPage.pickUpRequest.denyService3').replaceAll(':grader_company', companyToRequestPickUp.meta_name)}
              </p>
            </div>
          }

          <div className="d-flex justify-content-between w-100 mx-0 pt-4">
            <div>
              <button
                type="button"
                className="btn bg-red br-50px border-none m-auto px-4 text-weight-500 color-white"
                onClick={onCancel ? () => onCancel() : handleClose}>
                {I18n.t('js.common.button.cancel').toUpperCase()}
              </button>
            </div>

            <div>
              <button
                type="button"
                className="btn bg-intense-blue-imp br-50px border-none m-auto px-4 text-weight-500 color-white"
                disabled={invalidDay || !homePickUpFavoriteDay || !validHomePickUpHour() || (homePickUpAvailableAddresses?.length > 0 && !isDefined(homePickUpAddressId))}
                onClick={handleConfirm}
              >
                {I18n.t('js.common.button.confirm').toUpperCase()}
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default SubmissionListHomePickUpPopup;